var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BaseHeader',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Privacy Policy")]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }